const Accordion = class extends HTMLElement {
  static observedAttributes = ["is-product-accordion"];

  connectedCallback() {
    this.addEventListener("click", this.slideToggle.bind(this));
    this.insertFitGuide();

    // Open accordion items on page load if they have the `data-default-open` attribute
    setTimeout(() => {
      this.querySelector("[data-default-open] .ac-trigger")?.click();
    }, 1000);
  }

  slideToggle(e: MouseEvent) {
    const id = (e.target?.closest(".ac-trigger") as HTMLElement)?.dataset.slidetoggle;

    if (!id) return;
    const el: HTMLElement | null = this.querySelector(id);
    const isCollapsed = el?.clientHeight === 0;
    if (!el) return;

    const maxH = parseInt(getComputedStyle(el)?.maxHeight?.replace("px", ""));
    const toHeight = !isNaN(maxH) && maxH < el.scrollHeight ? maxH : el.scrollHeight;

    el.style.height = (isCollapsed ? toHeight : 0) + "px";
    isCollapsed ? el.closest(".ac")?.classList.add("is-active") : el.closest(".ac")?.classList.remove("is-active");
  }

  insertFitGuide() {
    const isProductAccordian = !!this.getAttribute("is-product-accordion");
    // Add in the fit guides on the PDP
    const fitGuide = document.querySelector("[data-fit-guide]");
    if (!isProductAccordian || !fitGuide) return;

    let data: null | {
      title?: string;
      description: string;
    } = null;

    try {
      data = JSON.parse(fitGuide.innerHTML);
    } catch (e) {
      console.error(e);
    }
    if (!data) return;

    const fit = document.createElement("li");
    fit.classList.add("ac");
    fit.innerHTML = /* HTML */ `
      <div class="text-md">
        <h2 class="ac-header">
          <button type="button" class="ac-trigger text-md" data-slidetoggle="#box-fit_guide">
            ${data.title || "Fit"}
            <ui-icon width="16" height="16" name="icon-chevron-down-large"></ui-icon>
          </button>
        </h2>
        <div class="ac-panel rte" id="box-fit_guide">
          <div class="inner-panel">
              ${data.description}
            </span>
          </div>
        </div>
      </div>
    `;

    const selector = this.querySelector(".size-guides") || this.querySelector(".product-details");
    selector ? selector?.after(fit) : this.querySelector("ul")?.appendChild(fit);
  }
};

customElements.define("ui-accordion", Accordion);
